import React, { PropsWithChildren } from 'react';
import * as Bixby from '$/core';

export interface IAhrefWithTargetProps {
  path: string;
  text?: string;
  rel?: string;
  classes?: string;
}

/**
 * Component exists to support opening app links in a new tab using target of _blank
 * Specifically, with handling for relative path versus absolute path for the CSCP window path prefix based on Bixby.Configuration.isStandAloneMode.
 * @param {string} path IMPORTANT!: must not start with slash, used with CSCP path prefix which has a trailing slash or with prepended slash depending on standalone vs non-standalone
 * @param {string} text the link display text
 * @param {string} rel optionally pass values like nofollow to be added to the a tag
 * @param {string} classes optional classes to add to the link
 */
const AhrefWithTarget: React.FC<PropsWithChildren<IAhrefWithTargetProps>> = ({
  path,
  text,
  classes = '',
  rel = '',
  children = undefined,
}: PropsWithChildren<IAhrefWithTargetProps>) => {
  const slashPrefixedPath = `/${path}`;
  const dynamicPathTargetBlank = Bixby.Configuration.isStandAloneMode
    ? slashPrefixedPath
    : `${Bixby.Configuration.cscpWindowPathPrefix}${path}`;
  const dynamicClassString = classes
    ? `${Bixby.Constants.DEFAULT_LINK_CLASSES} ${classes}`
    : Bixby.Constants.DEFAULT_LINK_CLASSES;
  const dynamicRel = rel ? { rel } : {};
  const content = children || text;
  return (
    <a className={dynamicClassString} href={dynamicPathTargetBlank} target="_blank" {...dynamicRel}>
      {content}
    </a>
  );
};
export default AhrefWithTarget;
